import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=296d7a4b&scoped=true"
import script from "./NotFound404.vue?vue&type=script&lang=js"
export * from "./NotFound404.vue?vue&type=script&lang=js"
import style0 from "./NotFound404.vue?vue&type=style&index=0&id=296d7a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d7a4b",
  null
  
)

export default component.exports